export default "__VITE_ASSET__84c7b8c0__"